import { Component } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { PasswortAenderungVO, TeilnehmerApiService } from "@core/api/v1";
import { NotificationService } from "@core/services/notification/notification.service";
import { MessageService } from "primeng/api";
import {CheckboxModule} from "primeng/checkbox";
import {DropdownModule} from "primeng/dropdown";
import {InputMaskModule} from "primeng/inputmask";
import {InputTextModule} from "primeng/inputtext";
import {ListboxModule} from "primeng/listbox";
import { FormBuilder, ReactiveFormsModule, Validators } from "@angular/forms";

@Component({
  selector: 'app-passwort-aendern',
  standalone: true,
    imports: [
        CheckboxModule,
        DropdownModule,
        InputMaskModule,
        InputTextModule,
        ListboxModule,
        ReactiveFormsModule
    ],
  templateUrl: './passwort-aendern.component.html',
  styleUrl: './passwort-aendern.component.scss'
})
export class PasswortAendernComponent {

    formular = this.formbuilder.group({
        altesPasswort: [''],
        neuesPasswort: ['', [Validators.required, Validators.minLength(7)]],
        neuesPwBestaetigen: ['', Validators.required],
    });

    protected resetToken?: string;

    constructor(private formbuilder: FormBuilder,
                private messageService: MessageService,
                private teilnehmerService: TeilnehmerApiService,
                private router: Router,
                private notificationService: NotificationService,
                private activatedRoute: ActivatedRoute) {
        this.activatedRoute.queryParams.subscribe(params => {
            this.resetToken = params['token'];
            if (! this.resetToken) {
                this.formular.controls['altesPasswort'].setValidators( [Validators.required] );
            } else {
                this.formular.controls['altesPasswort'].clearValidators();
            }
        });
    }

    aenderePasswort() {
        const request: PasswortAenderungVO = {
            neuesPasswort: this.formular.getRawValue().neuesPasswort!,
            altesPasswort: this.formular.getRawValue().altesPasswort ? this.formular.getRawValue().altesPasswort! : undefined,
            resetToken: this.resetToken ? this.resetToken : undefined,
        };

        if (! this.passwortValidierung()) {
            return;
        }

        if (this.resetToken) {
            this.teilnehmerService.resetPasswort(request).subscribe({
                next: response => {
                    this.notificationService.showSuccess("Passwort erfolgreich geändert");
                    this.router.navigate(['/']);
                },
                error: error => {
                    console.log(error.status);

                    if (error.status == 400) {
                        this.notificationService.showError("Altes Passwort stimmt nicht überein");
                        this.leereFelder();
                    }
                }
            });
        }
        else {
            this.teilnehmerService.passwortAendern(request).subscribe({
                next: response => {
                    this.notificationService.showSuccess("Passwort erfolgreich geändert");
                    this.router.navigate(['/']);
                },
                error: error => {
                    console.log(error.status);

                    if (error.status == 400) {
                        this.notificationService.showError("Altes Passwort stimmt nicht überein");
                        this.leereFelder();
                    }
                }
            });
        }
    }

    passwortValidierung(): boolean {
        if (this.formular.getRawValue().neuesPasswort != this.formular.getRawValue().neuesPwBestaetigen) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Passwörter stimmen nicht überein',
            });
            this.leereFelder();
            return false;
        } else if (this.formular.getRawValue().altesPasswort == this.formular.getRawValue().neuesPasswort) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Neues Passwort darf nicht mit dem alten Passwort übereinstimmen'
            });
            this.leereFelder();
            return false;
        }
        return true;
    }

    leereFelder() {
        this.formular.reset();
        const altesPasswortEingabe = document.getElementById("altesPwInput")
        altesPasswortEingabe?.focus();
    }
}
